import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling


function KSAGRF17_FAQ() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div >
    {/* Hero Section */}
    <div className="hero-banner">
      <div className="hero-content" >
        <h1 style={{ color: 'black' }}>{t('FAQ_SANSRS_Title')}</h1>
        
      </div>
      
    </div>
    
    

    {/* Content Section */}
    <div className="hero-banner" style={{ backgroundColor: 'white' }}>
        <div className="hero-content">
          
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_SANSRS_Q1')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_SANSRS_Q1R1')}</p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_SANSRS_Q1R2')}</p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_SANSRS_Q2')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_SANSRS_Q2R1')}</p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_SANSRS_Q3')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_SANSRS_Q3R1')}</p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_SANSRS_Q4')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_SANSRS_Q4R1')}</p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_SANSRS_Q5')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_SANSRS_Q5R1')}</p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_SANSRS_Q6')}</b>
          <ul>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_SANSRS_Q6R1')}</li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_SANSRS_Q6R2')}</li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_SANSRS_Q6R3')}</li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_SANSRS_Q6R4')}</li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_SANSRS_Q6R5')}</li>
          </ul></p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_SANSRS_Q7')}</b></p>
          <table className='table-container'>
        
        <tbody>
          <tr>
            <td ><b>{t('FAQ_SANSRS_Q7R1_Refsys')}</b></td>
            <td ><b>{t('FAQ_SANSRS_Q7R2_horshift')}</b></td>
          </tr>
          <tr>
            <td >{t('FAQ_SANSRS_Q7R1_ARAMCO')}</td>
            <td >{t('FAQ_SANSRS_Q7R1_ARAMCO_value')}</td>
          </tr>
          <tr>
            <td >{t('FAQ_SANSRS_Q7R1_ARAMCO1')}</td>
            <td >{t('FAQ_SANSRS_Q7R1_ARAMCO1_value')}</td>
          </tr>
          <tr>
            <td >{t('FAQ_SANSRS_Q7R1_GDMS')}</td>
            <td >{t('FAQ_SANSRS_Q7R1_GDMS_value')}</td>
          </tr>
          <tr>
            <td >{t('FAQ_SANSRS_Q7R1_MTRF')}</td>
            <td >{t('FAQ_SANSRS_Q7R1_MTRF_value')}</td>
          </tr>
          
          
        </tbody>
      </table>
      <p style={{ textAlign: 'justify' }}><b>{t('FAQ_SANSRS_Q8')}</b></p>
      <p style={{ textAlign: 'justify' }}>{t('FAQ_SANSRS_Q8R1_P1')}</p>


          <p style={{ textAlign: 'justify' }}>{t('FAQ_SANSRS_Q8R1_P2')}
          <ul>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_SANSRS_Q8R1_P3')}</li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_SANSRS_Q8R1_P4')}</li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_SANSRS_Q8R1_P5')}</li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_SANSRS_Q8R1_P6')}</li>
          </ul></p>

          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_SANSRS_Q9')}</b>
          <ul>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_SANSRS_Q9R1_P1')} <a  href="https://ksacors.geoportal.sa/RegisterAccount.aspx" target="_blank" rel="noopener noreferrer">
                  {t('KSA-CORS')}
                </a></li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_SANSRS_Q9R1_P2')}</li>
        
          </ul></p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_SANSRS_Q10')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_SANSRS_Q10R1')}</p>
         
          <br />          
        </div>
      </div>
      <div className="cards-space" style={{height:"40px"}}></div>
      
      
 
    
    </div>
);
}

export default KSAGRF17_FAQ;
